import React, { useState, useContext } from "react";

const UpdateAnnouncementContext = React.createContext();

const useUpdateAnnouncement = () => useContext(UpdateAnnouncementContext);

const UpdateAnnouncementProvider = ({ children }) => {
  const [updateAnnouncement, setUpdateAnnouncement] = useState(false);

  return (
    <UpdateAnnouncementContext.Provider
      value={{ updateAnnouncement, setUpdateAnnouncement }}
    >
      {children}
    </UpdateAnnouncementContext.Provider>
  );
};

export { useUpdateAnnouncement, UpdateAnnouncementProvider };
